exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.jsoneditor-vue div.jsoneditor-tree {\n  min-height: 150px !important\n}\n.testResult {\n  max-height: 200px;\n  overflow-y: auto\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6567d682","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/beast/decisions/Index.vue
// module id = 860
// module chunks = 1